import { render, staticRenderFns } from "./expertStatistics.vue?vue&type=template&id=4be8452c"
import script from "./expertStatistics.vue?vue&type=script&lang=js"
export * from "./expertStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports